export default [
    {
        path: '/manual-shipment-queue/list',
        name: 'manual_shipment_queue-list',
        component: () => import('@src/manual-shipment-queue/list'),
        meta: {
            title: 'Manuelle Versandaufträge',
            role: 'ROLE_LIST_MANUAL_SHIPMENT_QUEUES',
        },
    },
    {
        path: '/manual-shipment-queue/detail/:id',
        name: 'manual_shipment_queue-detail',
        component: () => import('@src/manual-shipment-queue/detail'),
        meta: {
            title: 'Manueller Versandauftrag',
            role: 'ROLE_SHOW_MANUAL_SHIPMENT_QUEUE',
        },
        props({ params }) {
            return {
                id: Number.parseInt(params.id),
            };
        },
    },
    {
        path: '/manual-shipment-queue/finish',
        name: 'manual_shipment_queue-finish',
        component: () => import('@src/manual-shipment-queue/finish'),
        meta: {
            title: 'Manuellen Versandauftrag abschließen',
            role: 'ROLE_FINISH_MANUAL_SHIPMENT_QUEUE',
        },
    },
];
